import type { PortalFeatureKey, PortalFeatureSettingsResponse, PortalFeatures } from "@wwrp/shared";
import { api } from "./client.js";

export const portalFeaturesApi = {
  list: () => api.get<PortalFeatureSettingsResponse>("/portal/features"),
  update: (key: PortalFeatureKey, enabled: boolean) =>
    api.put<PortalFeatureSettingsResponse>(`/admin/features/${key}`, { enabled }),
};
export type { PortalFeatureKey, PortalFeatures };
